import React from 'react';
import PropTypes from 'prop-types';

import './style.css';

const Disclaimer = ({ children, textAlign }) => (
  <div className={`c-disclaimer -${textAlign}`}>
    {children}
  </div>
);

Disclaimer.propTypes = {
  textAlign: PropTypes.string,
  children: PropTypes.node.isRequired
};

Disclaimer.defaultProps = {
  textAlign: 'left'
};

export default Disclaimer;



// WEBPACK FOOTER //
// ./src/components/disclaimer/index.js